import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  news: [],
  loading: false,
  error: null
}

// getters
const getters = {
  news (state) {
    return state.news
  },
  eigeneNews: (state) => (id) => {
    let items = []
    state.news.forEach(item => {
      if (item.an) {
        if (item.an.indexOf(id) !== -1) {
          items.push(item)
        }
      }
      if (item.cc) {
        if (item.cc.indexOf(id) !== -1) {
          items.push(item)
        }
      }
      if (item.bcc) {
        if (item.bcc.indexOf(id) !== -1) {
          items.push(item)
        }
      }
    })
    return items
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadNews ({commit}) {
    commit('setLoading', true)
    console.log('News laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('news').orderBy('datum', 'desc')
    .onSnapshot(snapshot => {
      const news = []
      snapshot.forEach(doc => {
        news.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedNews', news)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createEinNews ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('news').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteEinNewsData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('news').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteEinNews', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateEinNewsData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('news').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateEinNews', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedNews (state, payload) {
    state.news = payload
  },
  createEinNews (state, payload) {
    state.news.unshift(payload)
  },
  updateEinNews (state, payload) {
    const einNews = state.news.find(einNews => {
      return einNews.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        einNews[key] = payload[key]
      }
    })
  },
  deleteEinNews (state, payload) {
    let array = state.news
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.news = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/news_alt.js